// extracted by mini-css-extract-plugin
export default {"icon-container":"Icon_icon-container__zFOAg","icon":"Icon_icon__pCbcD"};